declare namespace $ {

	type $mol_button_minor__title_mvc_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_string__value_mvc_app_2 = $mol_type_enforce<
		ReturnType< $mvc_app['user_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_minor__title_mvc_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_paragraph__title_mvc_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_mvc_app_5 = $mol_type_enforce<
		ReturnType< $mvc_app['unit_id'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_mvc_app_6 = $mol_type_enforce<
		ReturnType< $mvc_app['unit_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_string__value_mvc_app_7 = $mol_type_enforce<
		ReturnType< $mvc_app['unit_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_major__title_mvc_app_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__title_mvc_app_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_string__value_mvc_app_10 = $mol_type_enforce<
		ReturnType< $mvc_app['skill_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_major__title_mvc_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__title_mvc_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_row__sub_mvc_app_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_row__sub_mvc_app_14 = $mol_type_enforce<
		ReturnType< $mvc_app['skill_list'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_row__sub_mvc_app_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_row__sub_mvc_app_16 = $mol_type_enforce<
		ReturnType< $mvc_app['units_list'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_major__title_mvc_app_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_list__rows_mvc_app_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $mvc_app extends $mol_page {
		Login( ): $mol_button_minor
		user_name( next?: string ): string
		User_name( ): $mol_string
		User_logout( ): $mol_button_minor
		Unit_length( ): $mol_paragraph
		unit_id( id: any): string
		Unit_id( id: any): $mol_paragraph
		unit_name( id: any, next?: string ): string
		Unit_name( id: any): $mol_paragraph
		Unit_name_change( id: any): $mol_string
		Unit_remove( id: any): $mol_button_major
		Unit_copy( id: any): $mol_button_major
		skill_name( id: any, next?: string ): string
		Skill_name( id: any): $mol_string
		Skill_remove( id: any): $mol_button_major
		Skill_add( id: any): $mol_button_major
		Skill( id: any): $mol_row
		skill_list( id: any): readonly(any)[]
		Skills( id: any): $mol_row
		Unit( id: any): $mol_row
		units_list( ): readonly(any)[]
		Units( ): $mol_row
		Unit_add( ): $mol_button_major
		Auth( ): $mol_list
		title( ): string
		user( next?: any ): any
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map